import { PagedResult } from "../../Models/PagedResult";
import { GetAllWhatsAppMessages, WhatsAppMessage, WhatsAppStatus, WhatsAppTemplate } from "../../Models/WhatsApp";
import { WhatsAppTemplateType } from "../../Enums/WhatsAppTemplateType";
import api from "../axios";

export const whatsAppService = {
  getStatus: async (): Promise<WhatsAppStatus> => {
    const response = await api.get('/whatsapp/status');
    return response.data;
  },

  getMessages: async (data: GetAllWhatsAppMessages): Promise<PagedResult<WhatsAppMessage>> => {
    const queryParams = new URLSearchParams();

    queryParams.append("page", data.page.toString());
    queryParams.append("pageSize", data.pageSize.toString());

    if (data.templateType !== undefined && data.templateType !== null) {
      queryParams.append("templateType", data.templateType.toString());
    }

    if (data.status !== undefined && data.status !== null) {
      queryParams.append("status", data.status.toString());
    }

    const response = await api.get(`/whatsapp/messages?${queryParams.toString()}`);
    return response.data;
  },

  getMessageCount: async (): Promise<number> => {
    const response = await api.get('/whatsapp/messages/count');
    return response.data;
  },

  getTemplates: async (): Promise<WhatsAppTemplate[]> => {
    const response = await api.get('/whatsapp/templates');
    return response.data;
  },

  updateTemplate: async (type: WhatsAppTemplateType, body: string): Promise<WhatsAppTemplate> => {
    const response = await api.put(`/whatsapp/templates/${type}`, { body });
    return response.data;
  },

  resetTemplate: async (type: WhatsAppTemplateType): Promise<WhatsAppTemplate> => {
    const response = await api.post(`/whatsapp/templates/${type}/reset`);
    return response.data;
  },

  syncMetaTemplates: async (): Promise<WhatsAppTemplate[]> => {
    const response = await api.post('/whatsapp/templates/meta-sync');
    return response.data;
  }
};
